// Helper used by _events-calendar.js to toggle the .is-active state on the
// custom select-looking element (Russian custom dropdown). Exposed on window
// because the original Sprockets bundle concatenated all components, so
// other modules referenced this function as a global.
window.selectLookingStateToggle = function (selector) {
  var $selector = $(selector)
  if ($selector.hasClass('is-active')) {
    $selector.removeClass('is-active')
  } else {
    $selector.addClass('is-active')
  }
}
